import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, ProgressBar, Button, Spinner } from 'react-bootstrap';
import { getApiUrl } from '../config/api';

const DashboardKamar = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataKamar, setDataKamar] = useState([]);
  const [time, setTime] = useState({ date: '', clock: '' });

  // Fallback / Initial Mock data matching the requested response format
  const mockData = [
    { "nm_kelas": "Kelas 1", "kapasitas": 52, "laki_isi": 17, "laki_ksg": 1, "perempuan_isi": 32, "perempuan_ksg": 2, "bayi_isi": 0, "anak_isi": 0, "kebidanan_isi": 0, "kebidanan_ksg": 0, "bebas": 0, "perbaikan_isi": 0 },
    { "nm_kelas": "Kelas 2", "kapasitas": 30, "laki_isi": 11, "laki_ksg": 1, "perempuan_isi": 17, "perempuan_ksg": 1, "bayi_isi": 0, "anak_isi": 0, "kebidanan_isi": 0, "kebidanan_ksg": 0, "bebas": 0, "perbaikan_isi": 0 },
    { "nm_kelas": "Kelas 3", "kapasitas": 8, "laki_isi": 4, "laki_ksg": 0, "perempuan_isi": 4, "perempuan_ksg": 0, "bayi_isi": 0, "anak_isi": 0, "kebidanan_isi": 0, "kebidanan_ksg": 0, "bebas": 0, "perbaikan_isi": 0 },
    { "nm_kelas": "Kelas VIP", "kapasitas": 3, "laki_isi": 2, "laki_ksg": 0, "perempuan_isi": 1, "perempuan_ksg": 0, "bayi_isi": 0, "anak_isi": 0, "kebidanan_isi": 0, "kebidanan_ksg": 0, "bebas": 0, "perbaikan_isi": 0 },
    { "nm_kelas": "Kelas ICU", "kapasitas": 7, "laki_isi": 5, "laki_ksg": 2, "perempuan_isi": 0, "perempuan_ksg": 0, "bayi_isi": 0, "anak_isi": 0, "kebidanan_isi": 0, "kebidanan_ksg": 0, "bebas": 0, "perbaikan_isi": 0 },
    { "nm_kelas": "Kelas Isolasi", "kapasitas": 6, "laki_isi": 2, "laki_ksg": 4, "perempuan_isi": 0, "perempuan_ksg": 0, "bayi_isi": 0, "anak_isi": 0, "kebidanan_isi": 0, "kebidanan_ksg": 0, "bebas": 0, "perbaikan_isi": 0 },
    { "nm_kelas": "Kelas Perinatologi", "kapasitas": 4, "laki_isi": 0, "laki_ksg": 0, "perempuan_isi": 3, "perempuan_ksg": 1, "bayi_isi": 0, "anak_isi": 0, "kebidanan_isi": 0, "kebidanan_ksg": 0, "bebas": 0, "perbaikan_isi": 0 },
    { "nm_kelas": "Kelas NICU", "kapasitas": 5, "laki_isi": 0, "laki_ksg": 0, "perempuan_isi": 5, "perempuan_ksg": 0, "bayi_isi": 0, "anak_isi": 0, "kebidanan_isi": 0, "kebidanan_ksg": 0, "bebas": 0, "perbaikan_isi": 0 }
  ];

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    const apiUrl = getApiUrl();
    try {
      const response = await fetch(`${apiUrl}/dashboard`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const json = await response.json();
      if (json && json.dashboard) {
        setDataKamar(json.dashboard);
      } else {
        setDataKamar(mockData);
      }
    } catch (err) {
      console.warn("Failed fetching backend /dashboard, using mock data:", err);
      // Fallback ke mock data
      setDataKamar(mockData);
      setError("Menggunakan data lokal/cache. Gagal terhubung ke backend server.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();

    // Update real-time clock
    const updateTime = () => {
      const now = new Date();
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      setTime({
        date: now.toLocaleDateString('id-ID', options),
        clock: now.toLocaleTimeString('id-ID') + ' WIB'
      });
    };
    updateTime();
    const clockInterval = setInterval(updateTime, 1000);
    const dataInterval = setInterval(fetchData, 300000); // 5 menit

    return () => {
      clearInterval(clockInterval);
      clearInterval(dataInterval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Hitung total akumulasi
  const totalKapasitas = dataKamar.reduce((acc, curr) => acc + (curr.kapasitas || 0), 0);
  
  // Total terisi: sum of laki_isi + perempuan_isi + bayi_isi + anak_isi + kebidanan_isi
  const totalTerisi = dataKamar.reduce((acc, curr) => 
    acc + (curr.laki_isi || 0) + (curr.perempuan_isi || 0) + (curr.bayi_isi || 0) + (curr.anak_isi || 0) + (curr.kebidanan_isi || 0)
  , 0);

  // Total kosong: Kapasitas - Terisi
  const totalKosong = totalKapasitas - totalTerisi;
  const totalBOR = totalKapasitas > 0 ? ((totalTerisi / totalKapasitas) * 100).toFixed(1) : 0;

  return (
    <div style={styles.dashboardContainer}>
      {/* ── FLOAT ACTION BAR (Kembali Ke Home + Refresh & Jam) ── */}
      <div style={styles.topMenuBar} className="shadow-sm">
        <div className="d-flex align-items-center gap-3">
          <Button
            variant="light"
            onClick={() => navigate('/home')}
            style={styles.backBtn}
            className="d-flex align-items-center gap-1.5"
          >
            <i className="bi bi-house-door-fill text-teal"></i>
            <span className="fw-semibold">Beranda SIMRS</span>
          </Button>

          <Button
            variant="outline-teal"
            onClick={fetchData}
            style={styles.refreshBtn}
            disabled={loading}
            className="d-flex align-items-center gap-1.5"
          >
            {loading ? (
              <Spinner animation="border" size="sm" variant="teal" />
            ) : (
              <i className="bi bi-arrow-clockwise text-teal"></i>
            )}
            <span className="fw-semibold text-teal-dark">Refresh</span>
          </Button>
          
          {error && (
            <span className="badge bg-warning-subtle text-warning-emphasis border border-warning-subtle px-2.5 py-1" style={{ fontSize: '0.73rem' }}>
              <i className="bi bi-exclamation-triangle-fill me-1"></i> {error}
            </span>
          )}
        </div>

        {/* Real-time Clock Info */}
        <div className="text-end d-none d-md-block">
          <div className="fw-bold text-dark-blue" style={{ fontSize: '0.85rem' }}>{time.date}</div>
          <div className="fw-bold text-teal" style={{ fontSize: '0.82rem' }}>{time.clock}</div>
        </div>
      </div>

      {/* ── DASHBOARD CORE CONTENT ── */}
      <Container fluid className="px-4 py-3 flex-grow-1 d-flex flex-column" style={{ minHeight: 0, overflowY: 'auto' }}>
        
        {/* Title */}
        <div className="text-center mb-3">
          <h2 style={styles.dashTitle} className="fw-bold">
            MONITOR KETERSEDIAAN TEMPAT TIDUR RAWAT INAP
          </h2>
          <p className="text-muted" style={{ fontSize: '0.82rem', margin: 0 }}>
            RS Mary Cileungsi Hijau • Sistem Informasi Management Rumah Sakit (Finance)
          </p>
        </div>

        {/* ── TOP METRICS CARDS ── */}
        <Row className="g-3 mb-4 flex-shrink-0">
          {/* Card 1: Kapasitas */}
          <Col lg={3} md={6}>
            <div style={{ ...styles.metricCard, background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', color: '#fff' }} className="shadow-sm">
              <div>
                <div style={styles.metricVal}>{totalKapasitas}</div>
                <div style={styles.metricLabel}>Total Kapasitas Tempat Tidur</div>
              </div>
              <div style={styles.metricIconWrap}><i className="bi bi-server"></i></div>
            </div>
          </Col>

          {/* Card 2: Terisi */}
          <Col lg={3} md={6}>
            <div style={{ ...styles.metricCard, background: 'linear-gradient(135deg, #be123c 0%, #9f1239 100%)', color: '#fff' }} className="shadow-sm">
              <div>
                <div style={styles.metricVal}>{totalTerisi}</div>
                <div style={styles.metricLabel}>Tempat Tidur Terisi (Pasien)</div>
              </div>
              <div style={styles.metricIconWrap}><i className="bi bi-person-fill-lock"></i></div>
            </div>
          </Col>

          {/* Card 3: Kosong */}
          <Col lg={3} md={6}>
            <div style={{ ...styles.metricCard, background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)', color: '#fff' }} className="shadow-sm">
              <div>
                <div style={styles.metricVal}>{totalKosong}</div>
                <div style={styles.metricLabel}>Tempat Tidur Kosong (Tersedia)</div>
              </div>
              <div style={styles.metricIconWrap}><i className="bi bi-door-open-fill"></i></div>
            </div>
          </Col>

          {/* Card 4: BOR */}
          <Col lg={3} md={6}>
            <div style={{ ...styles.metricCard, background: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)', color: '#fff' }} className="shadow-sm">
              <div>
                <div style={styles.metricVal}>{totalBOR}%</div>
                <div style={styles.metricLabel}>Bed Occupancy Rate (BOR)</div>
              </div>
              <div style={styles.metricIconWrap}><i className="bi bi-activity"></i></div>
            </div>
          </Col>
        </Row>

        {/* ── DETAILS ROW FOR CLASSES ── */}
        <Row className="g-3 flex-grow-1">
          {dataKamar.map((room, idx) => {
            const filledRoom = (room.laki_isi || 0) + (room.perempuan_isi || 0) + (room.bayi_isi || 0) + (room.anak_isi || 0) + (room.kebidanan_isi || 0);
            const availableRoom = (room.kapasitas || 0) - filledRoom;
            const percentage = room.kapasitas > 0 ? Math.round((filledRoom / room.kapasitas) * 100) : 0;

            // Class colors theme
            const isCritical = percentage >= 90;
            const isHigh = percentage >= 75 && percentage < 90;
            const themeColor = isCritical ? '#ef4444' : isHigh ? '#f59e0b' : '#10b981';

            return (
              <Col xl={3} lg={4} md={6} key={idx}>
                <Card style={styles.roomCard} className="border shadow-sm h-100">
                  <div style={{ ...styles.roomCardHeader, borderLeft: `6px solid ${themeColor}`, padding: '0.8rem 1rem' }} className="d-flex justify-content-between align-items-center">
                    <span className="fw-extrabold text-dark-blue" style={{ fontSize: '1rem', fontWeight: '800' }}>{room.nm_kelas}</span>
                    <span className="badge rounded-pill px-3 py-1.5 fw-bold" style={{ background: themeColor === '#10b981' ? '#ecfdf5' : themeColor === '#f59e0b' ? '#fffbeb' : '#fef2f2', color: themeColor, fontSize: '0.75rem', border: `1px solid ${themeColor}50` }}>
                      {availableRoom} Bed Kosong
                    </span>
                  </div>

                  <Card.Body className="d-flex flex-column justify-content-between p-3" style={{ background: '#ffffff' }}>
                    {/* Capacity indicators */}
                    <div className="mb-3 p-3 rounded-3" style={{ background: 'linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)', border: '1.5px solid #cbd5e1' }}>
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div>
                          <div className="text-muted" style={{ fontSize: '0.72rem', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Hunian Kamar</div>
                          <div style={{ fontSize: '2.2rem', fontWeight: '900', color: '#0f172a', lineHeight: 1.0, marginTop: '2px' }}>
                            {filledRoom} <span style={{ fontSize: '1rem', fontWeight: '700', color: '#475569' }}>/ {room.kapasitas} Bed</span>
                          </div>
                        </div>
                        <div className="text-end">
                          <span className="fw-extrabold px-3 py-1.5 rounded-3" style={{ fontSize: '1.1rem', fontWeight: '900', background: themeColor === '#10b981' ? '#d1fae5' : themeColor === '#f59e0b' ? '#fef3c7' : '#fee2e2', color: themeColor, border: `1.5px solid ${themeColor}60` }}>
                            {percentage}%
                          </span>
                        </div>
                      </div>
                      <ProgressBar
                        now={percentage}
                        style={{ height: '11px', borderRadius: '6px', border: '1px solid rgba(0,0,0,0.05)' }}
                        variant={isCritical ? "danger" : isHigh ? "warning" : "success"}
                      />
                    </div>

                    {/* Breakdown gender / details */}
                    <div className="pt-2.5 border-top">
                      {/* Laki-Laki Section */}
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <span className="fw-bold text-primary-emphasis" style={{ fontSize: '0.78rem' }}>
                          <i className="bi bi-gender-male me-1"></i>Laki-Laki
                        </span>
                        <div className="d-flex gap-1.5">
                          <span className="px-2 py-0.5 rounded fw-bold" style={{ fontSize: '0.72rem', background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca' }}>
                            {room.laki_isi || 0} Terisi
                          </span>
                          <span className="px-2 py-0.5 rounded fw-bold" style={{ fontSize: '0.72rem', background: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0' }}>
                            {room.laki_ksg || 0} Kosong
                          </span>
                        </div>
                      </div>

                      {/* Perempuan Section */}
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fw-bold text-danger-emphasis" style={{ fontSize: '0.78rem' }}>
                          <i className="bi bi-gender-female me-1"></i>Perempuan
                        </span>
                        <div className="d-flex gap-1.5">
                          <span className="px-2 py-0.5 rounded fw-bold" style={{ fontSize: '0.72rem', background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca' }}>
                            {room.perempuan_isi || 0} Terisi
                          </span>
                          <span className="px-2 py-0.5 rounded fw-bold" style={{ fontSize: '0.72rem', background: '#f0fdf4', color: '#16a34a', border: '1px solid #bbf7d0' }}>
                            {room.perempuan_ksg || 0} Kosong
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Additional Patient Breakdown if any */}
                    {(room.bayi_isi > 0 || room.anak_isi > 0 || room.kebidanan_isi > 0) && (
                      <div style={styles.extraDetails} className="mt-3 p-2 rounded bg-light border border-light-subtle">
                        {room.bayi_isi > 0 && <span className="badge bg-info-subtle text-info-emphasis me-1" style={{ fontSize: '0.7rem' }}><i className="bi bi-baby me-0.5"></i>Bayi: {room.bayi_isi}</span>}
                        {room.anak_isi > 0 && <span className="badge bg-warning-subtle text-warning-emphasis me-1" style={{ fontSize: '0.7rem' }}><i className="bi bi-person-fill me-0.5"></i>Anak: {room.anak_isi}</span>}
                        {room.kebidanan_isi > 0 && <span className="badge bg-danger-subtle text-danger-emphasis" style={{ fontSize: '0.7rem' }}><i className="bi bi-gender-female me-0.5"></i>Kebidanan: {room.kebidanan_isi}</span>}
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
};

// ══════════════ STYLES ══════════════
const styles = {
  dashboardContainer: {
    width: '100vw',
    height: '100vh',
    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
    color: '#1e293b',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  topMenuBar: {
    background: '#ffffff',
    borderBottom: '1px solid #e2e8f0',
    padding: '0.65rem 1.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexShrink: 0,
  },
  backBtn: {
    padding: '0.4rem 0.95rem',
    borderRadius: '8px',
    border: '1px solid #bae6fd',
    background: 'linear-gradient(180deg, #ffffff 0%, #f0f9ff 100%)',
    fontSize: '0.8rem',
    boxShadow: '0 2px 4px rgba(0,0,0,0.03)',
  },
  refreshBtn: {
    padding: '0.4rem 0.95rem',
    borderRadius: '8px',
    border: '1px solid #cbd5e1',
    background: '#ffffff',
    fontSize: '0.8rem',
    color: '#0f766e',
    boxShadow: '0 2px 4px rgba(0,0,0,0.03)',
  },
  dashTitle: {
    fontSize: '1.25rem',
    letterSpacing: '0.5px',
    color: '#0f172a',
    margin: '0 0 0.15rem 0',
  },
  metricCard: {
    borderRadius: '14px',
    padding: '0.9rem 1.3rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  metricVal: {
    fontSize: '1.75rem',
    fontWeight: '800',
    lineHeight: 1.1,
  },
  metricLabel: {
    fontSize: '0.73rem',
    opacity: 0.85,
    fontWeight: '500',
    marginTop: '0.15rem',
  },
  metricIconWrap: {
    background: 'rgba(255, 255, 255, 0.18)',
    padding: '7px 11px',
    borderRadius: '10px',
    fontSize: '1.35rem',
  },
  roomCard: {
    borderRadius: '14px',
    overflow: 'hidden',
    border: '1.5px solid #cbd5e1',
    boxShadow: '0 8px 30px rgba(15, 23, 42, 0.08)',
  },
  roomCardHeader: {
    background: '#f8fafc',
    padding: '0.65rem 1rem',
    fontWeight: '600',
    borderBottom: '1px solid #edf2f7',
  },
  detailGrid: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  genderTitle: {
    fontSize: '0.68rem',
    fontWeight: '600',
    color: '#64748b',
    textTransform: 'uppercase',
    letterSpacing: '0.2px',
    marginBottom: '2px',
  },
  genderStats: {
    fontSize: '0.85rem',
    fontWeight: '700',
  },
  extraDetails: {
    fontSize: '0.68rem',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    justifyContent: 'center',
  }
};

export default DashboardKamar;
